import {
	ActionButton,
	IconComponent,
	Popover,
	PopoverContent,
	PopoverTrigger
} from "../../../components";
import LinkEditBlock from "../../../extensions/Link/components/LinkEditBlock";

function LinkEditPopover(props) {
	function onSetLink(link, text, openInNewTab) {
		if (props.action) {
			props.action({ link, text, openInNewTab });
		}
	}

	return (
		<Popover>
			<PopoverTrigger disabled={props?.disabled} asChild>
				<ActionButton
					tooltip={props?.tooltip}
					isActive={props?.isActive}
					disabled={props?.disabled}
				>
					<IconComponent name={props?.icon} />
				</ActionButton>
			</PopoverTrigger>
			<PopoverContent
				hideWhenDetached
				className="richtext-w-full"
				align="start"
				side="bottom"
			>
				<LinkEditBlock editor={props.editor} onSetLink={onSetLink} />
			</PopoverContent>
		</Popover>
	);
}

export default LinkEditPopover;
